import {XH, hoistCmp} from '@xh/hoist/core';
import {WatchlistPanelModel} from './WatchlistPanelModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {fragment, vbox} from '@xh/hoist/cmp/layout';
import {grid} from '@xh/hoist/cmp/grid';
import {watchlistDialog} from './WatchlistDialog';
import './WatchlistPanel.scss';
import {itemRenderer} from './WatchlistItem';
import {watchlistExpanded} from './WatchlistExpanded';
import {compactToolbarButton, compactToolbarSelect, toolbarButtonSeparator} from '../../../../cmp/toolbar/Toolbar';

export const watchlist = hoistCmp.factory<WatchlistPanelModel>({
    render({model}) {
        return fragment(
            panel({
                className: 'watchlist',
                compactHeader: true,
                title: 'Watchlist',
                icon: Icon.eye(),
                headerItems: [
                    button({
                        disabled: false,
                        icon: Icon.openExternal(),
                        onClick: () => model.showExpanded()
                    })
                ],
                tbar: watchlistToolbar(),
                item: itemList(),
                mask: model.apiTask
            }),
            watchlistDialog(),
            watchlistExpanded()
        );
    }
});

const itemList = hoistCmp.factory<WatchlistPanelModel>(({model}) => {
    if (model.quoteGridModel) return grid({model: model.quoteGridModel, className: 'watchlist__quote-grid'});

    return vbox({
        className: 'watchlist__rows',
        overflowY: 'auto',
        flex: 1,
        items: model.store.allRecords.map(r => itemRenderer({key: r.id, model, record: r}))
    });
});

const watchlistToolbar = hoistCmp.factory<WatchlistPanelModel>({
    render({model}) {
        return toolbar({
            compact: true,
            items: [
                compactToolbarSelect({
                    flex: 1,
                    bind: 'activeWatchListId',
                    options: XH.watchListService.watchLists
                }),
                compactToolbarButton({
                    className: 'watchlist__button',
                    icon: Icon.add(),
                    intent: 'success',
                    onClick: () => model.addList()
                }),
                toolbarButtonSeparator(),
                compactToolbarButton({
                    className: 'watchlist__button',
                    icon: Icon.edit(),
                    intent: 'primary',
                    onClick: () => model.editList()
                }),
                toolbarButtonSeparator(),
                compactToolbarButton({
                    className: 'watchlist__button',
                    icon: Icon.delete(),
                    intent: 'danger',
                    onClick: () => model.deleteList()
                })
            ]
        });
    }
});
